import { auth } from '../actions/actionTypes';
export const authInitialState = {
    user: null,
    isAuthenticated: false,
};
export default function (state = authInitialState, action) {
    switch (action.type) {
        case auth.DISPATCH_USER:
            const dispatchUserPayload = action.payload;
            return { ...state, user: dispatchUserPayload };
        case auth.USER_LOADED:
            const userLoadedPayload = action.payload;
            return { ...state, isAuthenticated: true, isLoading: false, user: { ...state.user, ...userLoadedPayload } };
        case auth.UPDATE_USER:
            const updateUserPayload = action.payload;
            return { ...state, user: { ...state.user, ...updateUserPayload } };
        case auth.UPDATE_STORAGE_USED:
            const updateStorageUsedPayload = action.payload;
            return {
                ...state,
                user: { ...state.user, vaultStorage: (state.user?.vaultStorage ?? 0) + updateStorageUsedPayload },
            };
        case auth.LOGOUT_SUCCESSFUL:
            return authInitialState;
        default:
            return state;
    }
}
